export { VpHookFormRatingInput } from './VpHookFormRatingInput';



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpHookFormRatingInput/index.js